import { render, staticRenderFns } from "./WaterDataProfile.vue?vue&type=template&id=06dd87a7&"
import script from "./WaterDataProfile.vue?vue&type=script&lang=js&"
export * from "./WaterDataProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports